import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model

/**
 * Class representing the AllTActionsView.
 * @extends JetView
 */
export default class AllTActionsView extends JetView {
    /**
     * Configures the view layout and data table.
     * @returns {Object} The configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Data table view
            select: true, // Enable row selection
            columns: [
                { id: 'id', header: '#', width: 40, sort: 'int' }, // Column for ID
                {
                    id: 'status', // Column for payment status
                    header: '',
                    width: 40,
                    css: 'status',
                    sort: 'text',
                    template: (data) => {
                        // Template for displaying status icons
                        let icon = '';
                        if (data.status === 'success') icon = 'check-circle';
                        else if (data.status === 'failed') icon = 'alert-box';
                        else icon = 'clock';
                        return `<span class='webix_icon mdi mdi-${icon} ${data.status}'></span>`;
                    },
                },
                {
                    id: 'date', // Column for date
                    header: _('Fecha'), // Localized header
                    fillspace: 2,
                    minWidth: 150,
                    sort: 'date',
                    format: dateFormat, // Date format
                },
                {
                    id: '', // Column for payment method
                    header: _('Payment'), // Localized header
                    fillspace: 3,
                    minWidth: 240,
                    sort: 'text',
                    template: (data) => {
                        // Template for displaying payment method
                        return `<img class="method" src="data/images/${data.method}.svg" />${data.method} ${data.number || ''}`;
                    },
                },
                {
                    id: '', // Column for purchase details
                    header: _('Purchase'), // Localized header
                    fillspace: 4,
                    minWidth: 200,
                    sort: 'text',
                    template: (
                        data, // Template for displaying purchase information
                    ) => `${data.name} / ${data.city} / ${data.country}`,
                },
                {
                    id: 'type', // Column for transaction type
                    header: '+/-', // Header for transaction type
                    sort: 'int',
                    css: 'type',
                    fillspace: 1,
                    minWidth: 30,
                    template: (data) => {
                        // Template for displaying transaction type icons
                        let type = data.type ? 'plus incoming' : 'minus payment';
                        return `<span class='webix_icon mdi mdi-${type}'></span>`;
                    },
                },
                {
                    id: 'sum', // Column for transaction sum
                    header: _('Sum'), // Localized header
                    sort: 'int',
                    fillspace: 1,
                    minWidth: 70,
                    format: webix.i18n.priceFormat, // Price format
                    exportType: 'number', // Export type for the column
                },
                {
                    id: 'left', // Column for remaining amount
                    header: _('Left'), // Localized header
                    fillspace: 1,
                    minWidth: 70,
                    sort: 'int',
                    format: webix.i18n.priceFormat, // Price format
                    exportType: 'number', // Export type for the column
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        const list_length = this.app.config.listLength; // Maximum list length
        grid.sync(allpayments, function () {
            // Synchronize grid with allpayments model
            this.filter((obj) => obj.id <= list_length); // Filter based on list length
        });
        this.on(this.app, 'tactions:filter', (type) => {
            // Event listener for filtering actions
            if (type === 'all')
                grid.filter(); // Show all records
            else grid.filter((obj) => obj.type == type); // Filter by type
        });
        grid.attachEvent('onAfterSelect', (obj) => {
            // Event after row selection
            const record = allpayments.getItem(obj.row); // Get selected record
            this.app.callEvent('taction:select', [record]); // Trigger select event
        });
        grid.attachEvent(
            'onBeforeUnSelect',
            () =>
                // Event before unselecting a row
                this.app.callEvent('taction:select'), // Trigger select event
        );
        this.on(this.app, 'person:select', (person) => {
            // Event listener for person selection
            grid.select(person.company); // Select company in grid
            grid.showItem(person.company); // Show selected item
        });
        this.on(this.app, 'date:select', (date) => {
            // Event listener for date selection
            const taction = grid.find((obj) => {
                // Find transaction by date
                return obj.date.toString().slice(0, 14) === date.toString().slice(0, 14);
            });
            if (taction.length && grid.data.order.find(taction[0].id) !== -1) {
                // Check if transaction exists
                grid.select(taction[0].id); // Select transaction
                grid.showItem(taction[0].id); // Show selected item
            } else {
                grid.clearSelection(); // Clear selection if no transaction found
                webix.message(_('Nothing on this day')); // Show message if no records
            }
        });
    }
}

// FILE DOCUMENTED
